import {
  UPDATING_WAREHOUSE_SETTINGS,
  UPDATED_WAREHOUSE_SETTINGS,
  UPDATE_WAREHOUSE_SETTINGS_ERROR
} from 'actions'

const initialState = {
  isSubmittingConnectionForm: false,
  didFailToSubmitConnectionForm: false
}

export default function (state = initialState, { type }) {
  switch (type) {
    case UPDATING_WAREHOUSE_SETTINGS:
      return {
        ...state,
        didFailToSubmitConnectionForm: false,
        isSubmittingConnectionForm: true
      }
    case UPDATED_WAREHOUSE_SETTINGS:
      return {
        ...state,
        didFailToSubmitConnectionForm: false,
        isSubmittingConnectionForm: false
      }
    case UPDATE_WAREHOUSE_SETTINGS_ERROR:
      return {
        ...state,
        didFailToSubmitConnectionForm: true,
        isSubmittingConnectionForm: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/warehouse-settings.js